function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 208.45 97"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M64.61 94.71c-.48 0-.95-.15-1.35-.44L3.22 50.34c-.59-.43-.94-1.11-.94-1.84s.35-1.41.94-1.84L63.26 2.72c.4-.29.87-.44 1.35-.44.35 0 .71.08 1.03.25.77.39 1.25 1.18 1.25 2.04v22.82h46.15c1.26 0 2.28 1.02 2.28 2.28v37.65c0 1.26-1.02 2.28-2.28 2.28H66.89v22.82c0 .86-.48 1.65-1.25 2.04-.33.17-.68.25-1.03.25Z",
  style: {
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.61 4.57v25.1h48.44v37.65H64.61v25.1L4.57 48.5 64.61 4.57m0-4.57c-.95 0-1.9.3-2.7.88L1.87 44.81C.69 45.67 0 47.04 0 48.5s.69 2.83 1.87 3.69l60.04 43.93a4.596 4.596 0 0 0 4.77.39c1.53-.78 2.5-2.35 2.5-4.07V71.9h43.87c2.52 0 4.57-2.05 4.57-4.57V29.67c0-2.52-2.05-4.57-4.57-4.57H69.18V4.57c0-1.72-.97-3.29-2.5-4.07-.65-.33-1.36-.49-2.07-.49Z",
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 132.88,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 161.68,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 190.48,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}));
export default SvgArrowLeft;